import React from 'react'

import { ButtonSquare } from '@/modules/base/components/buttons'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import { ModalBig } from '@/modules/base/components/modal/index'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import IconBanking from '@assets/images/icons/icon_banking.svg'
import IconBuhlBanking from '@assets/images/banking/logo_buhlbanking.svg?url'
import ImageBanking from '@assets/images/grafik_banking_modal.svg?url'
import lang from '@/lang'
import { isMeinBuero } from '@/utils/build-env'
import { FINANCE_API } from '@/modules/banking/constants'

const isMeinbuero = isMeinBuero()

const { ACCOUNT_TYPE } = FINANCE_API
const EXCLUDED_ACCOUNT_TYPES = [
  ACCOUNT_TYPE.CASH_JOURNAL,
  ACCOUNT_TYPE.CLEARING_ACCOUNT,
  ACCOUNT_TYPE.PAYPAL,
  ACCOUNT_TYPE.CASH_JOURNAL_POS,
  ACCOUNT_TYPE.CLEARING_ACCOUNT_POS,
]
export const showBankAccountModal = (bankAccounts) => {
  return bankAccounts
    .filter(({ accountType }) => !EXCLUDED_ACCOUNT_TYPES.includes(accountType))
    .map((bankAccount) => {
      const { id, accountName } = bankAccount
      return {
        label: accountName,
        value: id,
        bankAccount,
      }
    }).length === 0
}

const useStyles = makeStyles((theme) => {
  return {
    contentWrapper: {
      display: 'flex',
      width: '100%',
      height: 580,
    },
    content: {
      width: 640,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    contentRight: {
      position: 'relative',
      width: 410,
      backgroundColor: isMeinbuero ? theme.darkBlue : theme.colorPrimaryButtonBackgroundHover,
    },
    title: {
      fontSize: theme.fontSizes.xlarge,
      color: theme.black,
      paddingTop: 20,
      paddingBottom: 20,
    },
    text: {
      color: theme.black,
      textAlign: 'center',
    },
    button: {
      marginTop: 20,
      marginBottom: 10,
    },
    back: {
      cursor: 'pointer',
      fontSize: theme.fontSizes.default,
      color: theme.colorPrimaryButtonBackground,
      width: '100%',
      height: 45,
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
    },
    bankingLogo: {
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'end',
      height: '100%',
      padding: '30px',
    },
    image: {
      left: '-45px',
      position: 'absolute',
    },
  }
})

const OnlineBankingModal = (props) => {
  const { onConfirm, onAbort, open, dataQsId } = props
  const classes = useStyles()

  const buttons = (
    <div className={classes.footerWrapper}>
      <ButtonSquare
        dataQsId={`${dataQsId}-confirm`}
        className={classes.button}
        label={'Konto anbinden'}
        onClick={onConfirm}
      />
      <div className={classes.back} onClick={onAbort}>Später</div>
    </div>
  )

  return (
    <ModalBig
      open={open}
      width={1050}
      modalspace={0}
      firstchildpaddingtop={0}
      paddingtop={0}
      dataQsId={dataQsId}>
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <SVGIcon svg={IconBanking} width="25px" height="25px" />
          <span className={classes.title}>{lang.onlineBankingModal.linkNow}</span>
          <p className={classes.text}>{lang.onlineBankingModal.description}</p>
          <p className={classes.text} dangerouslySetInnerHTML={{ __html: lang.onlineBankingModal.description2 }} />
          {buttons}
        </div>
        <div className={classes.contentRight}>
          <SVGIcon svg={ImageBanking} className={classes.image} />
          <SVGIcon svg={IconBuhlBanking} width="110px" height="20px" className={classes.bankingLogo} />
        </div>
      </div>
    </ModalBig>
  )
}

OnlineBankingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onAbort: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  dataQsId: PropTypes.string.isRequired,
}

export default OnlineBankingModal
